import { render, staticRenderFns } from "./main-view.vue?vue&type=template&id=696b262f&scoped=true&"
import script from "./main-view.vue?vue&type=script&lang=js&"
export * from "./main-view.vue?vue&type=script&lang=js&"
import style0 from "./main-view.vue?vue&type=style&index=0&id=696b262f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696b262f",
  null
  
)

export default component.exports